import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { SharedServices } from '../../../../../../services/shared.services'
import { AuthService } from '../../../../../../services/auth.services'
import { FormBuilder } from '@angular/forms'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import * as $ from 'jquery'

@Component({
    selector: 'app-modal-client-detail-slideshow-xray',
    templateUrl: './modal-client-detail-slideshow-xray.component.html',
    styleUrls: [
        './modal-client-detail-slideshow-xray.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalClientDetailSlideshowXrayComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN: Boolean = true
    option_SlideshowXray = 'active'
    TabSlideshowXrayClass
    index: any = 0
    arrAllXray: any[] = []
    jsonXray: any = {}
    tabName: any = 'xp-all'
    arrSlideshowXray: any[] = []
    arrShowStatus: any[] = []
    status: any
    arrSlideshowTooth
    arrTabSlideshowXray = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]

    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any

    // uploadImageForm: FormGroup;
    senMax: any = 100
    max: any = 0
    valChange: any = 0
    option_Slideshow: any = 'hidden'
    matrixImage: any[] = []
    arrImage: any[] = []
    emitTabName: any = {}
    animationDuration: any = 300
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef

    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []

    unscrTabName
    unscrIndex
    unscrAllArrClientTop
    getInfoIndex = undefined
    page = 'slideshow'
    unscrPage

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices) {
        this.option_SlideshowXray = 'active'
        this.TabSlideshowXrayClass = 'option_0'
        this.option_Slideshow = 'active'
    }

    ngOnInit() {
        this.unscrTabName = this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            if (infoTabName != null && infoTabName['tabName'] != undefined) {
                this.tabName = infoTabName['tabName']
            } else {
                this.tabName = 'xp-all'
            }
            const tmpStr: String = this.tabName
            if (tmpStr.includes('xp')) {
                this.getArrClientTop()
            }
        })
        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        // this.getValueSlider();
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrTabName)
            this.unscrTabName.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowXray)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('xp')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowXray)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowXray)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        const tmpStr: String = this.tabName
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'slideshow') {
                this.arrImage = []
                this.arrShowStatus = []
                this.matrixImage = []
                this.index = infoIndex['index']
                this.getInfoIndex = infoIndex
                if (tmpStr.includes('xp') && this.arrAllXray.length > 0) {
                    // const arrAll: any = this.clientTopServices.returnArrAll();
                    this.max = this.arrAllXray.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.ValueAssignOneDistance * this.index
                    } else {
                        this.valChange = 0
                    }
                    if (this.arrAllXray[this.index] != undefined) {
                        this.jsonXray = this.arrAllXray[this.index]
                        this.initJsonXray(this.arrAllXray[this.index])
                    }
                }
            } else {
                this.valChange = 0
            }
        })
    }

    getDataShow() {
        const tmpStr: String = this.tabName
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            if (arrAll != null && arrAll['slideshow'] != undefined && arrAll['slideshow'].length > 0) {
                if (this.page == 'slideshow') {
                    this.arrAllXray = arrAll['slideshow']
                    if (tmpStr.includes('xp')) {
                        if (this.arrAllXray.length > 0 && this.getInfoIndex) {
                            this.max = this.arrAllXray.length - 1
                            if (this.max > 0) {
                                this.ValueAssignOneDistance = this.senMax / this.max
                                this.valChange = this.ValueAssignOneDistance * this.index
                            } else {
                                this.valChange = 0
                            }
                            if (this.arrAllXray[this.index] != undefined) {
                                this.jsonXray = this.arrAllXray[this.index]
                                this.initJsonXray(this.arrAllXray[this.index])
                            }
                        }
                    }
                }
            } else {
                this.valChange = 0
                this.arrSlideshowXray = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrSlideshowXray)
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            if (this.arrAllXray[this.index] != undefined) {
                this.jsonXray = this.arrAllXray[this.index]
                this.initJsonXray(this.jsonXray)
                this.arrSlideshowXray = this.jsonXray[this.tabName]
            }
            this.valChange = assign
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.index = 0
            this.valChange = 0
            if (this.arrAllXray[this.index] != undefined) {
                this.jsonXray = this.arrAllXray[this.index]
                this.initJsonXray(this.jsonXray)
                this.arrSlideshowXray = this.jsonXray[this.tabName]
            }
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrSlideshowXray && this.arrSlideshowXray.length > 0) {
                const tmp: any = this.arrSlideshowXray[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    initJsonXray(json) {
        this.jsonXray['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationXray(this.jsonXray)
    }

    getArrRegistrationXray(arrXray) {
        this.arrSlideshowXray = arrXray[this.tabName]
        this.getShowStatus(this.arrSlideshowXray)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
            })
        }
        this.resetMatrixMovedUpPage()
    }

    toggleTabRegistrationXrayItem(id, event) {
        this.TabSlideshowXrayClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'xp-all'
                break
            case 'option_1':
                this.tabName = 'xp-1'
                break
            case 'option_2':
                this.tabName = 'xp-2'
                break
            case 'option_3':
                this.tabName = 'xp-3'
                break
            case 'option_4':
                this.tabName = 'xp-4'
                break
            case 'option_5':
                this.tabName = 'xp-5'
                break
            case 'option_6':
                this.tabName = 'xp-6'
                break
            default:
                this.tabName = 'xp-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.emitTabName['tabName'] = this.tabName
        this.arrSlideshowXray = this.jsonXray[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrSlideshowXray)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowXray/modal-client-detail-slideshow-xray.component.ts